import { render, staticRenderFns } from "./ServisneOperacije.vue?vue&type=template&id=59736f12&scoped=true&"
import script from "./ServisneOperacije.vue?vue&type=script&lang=ts&"
export * from "./ServisneOperacije.vue?vue&type=script&lang=ts&"
import style0 from "./ServisneOperacije.vue?vue&type=style&index=0&id=59736f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59736f12",
  null
  
)

export default component.exports